"use client";
import GlobalErrorImg from "../../../public/images/sorry_for_inconvenience.png";
import { usePathname } from "next/navigation";
import { captureError } from "@/utils/common.helpers";
import { reportRumError } from "@/lib/datadog-rum";
import { useEffect } from "react";
import { useClientTranslations } from "@/hooks/useClientTranslations";
import { Error } from "@/components/Error";
import { PageViewedEventPageNameEnum } from "@/constants/constants";

export const ErrorHandler = ({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) => {
  const { t } = useClientTranslations();
  const pathName = usePathname();

  const errorString = JSON.stringify({
    page_name: "error.tsx",
    message: error.message,
    stack: error.stack,
    name: error.name,
    pathname: pathName,
  });

  useEffect(() => {
    reportRumError(error, { context: "page_error", pathname: pathName });
    captureError(error);
  }, []);

  return (
    <>
      <Error
        gap={4}
        onButtonClick={reset}
        buttonLabel={t("consumption_screen_error.retry_cta")}
        buttonLink={pathName}
        description={t("consumption_screen_error.description")}
        imageAlt="Error Image"
        imageSrc={GlobalErrorImg}
        mainText={t("consumption_screen_error.heading")}
        errorPageName={PageViewedEventPageNameEnum.globalErrorPage}
        errorString={errorString}
      />
    </>
  );
};

export default ErrorHandler;
